<template>
  <div>
    <b-modal
      id="modal-1"
      ref="form-popup"
      size="lg"
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
    >
      <a
        class="btn-close"
        @click="popupHide"
      >
        <img
          :src="require('@/assets/images/close.png')"
          alt=""
        >
      </a>
      <div class="modal-text mb-1">
        <h4 class="mb-2">
          {{ formTitle }}</h4>
        <div class="form-s">
          <b-row>
            <b-col
              lg="6"
              sm="12"
            >
              <b-form-group
                label="Channel Name"
                label-for="v-channel-name"
              >
                <b-form-input
                  id="v-channel-name"
                  v-model="dataForm.channel"
                  placeholder="Type Channel Name"
                />
              </b-form-group>
            </b-col>
            <b-col
              lg="6"
              sm="12"
            >
              <b-form-group
                label="Volume"
                label-for="v-volume"
              >
                <b-form-input
                  id="v-volume"
                  v-model="dataForm.volume"
                  placeholder="Input Channel Volume"
                />
              </b-form-group>
            </b-col>
            <b-col
              lg="6"
              sm="12"
            >
              <b-form-group
                label="Remarks"
                label-for="v-remarks"
              >
                <b-form-input
                  id="v-remarks"
                  v-model="dataForm.remarks"
                  placeholder="Add Remarks for Channel"
                />
              </b-form-group>
            </b-col>
            <b-col
              lg="6"
              sm="12"
            >
              <b-form-group
                label="Format"
                label-for="v-format"
              >
                <b-form-input
                  id="v-format"
                  v-model="dataForm.format"
                  placeholder="Input Channel Format"
                />
              </b-form-group>
            </b-col>
            <b-col
              lg="4"
              sm="12"
            >
              <b-form-group
                label="Buy Method"
                label-for="v-method"
              >
                <v-select
                  id="v-method"
                  v-model="dataForm.methode"
                  :options="options.method"
                  :reduce="item => item.id"
                  label="label"
                />
              </b-form-group>
            </b-col>
            <b-col
              lg="4"
              sm="12"
            >
              <b-form-group
                label="Pricing"
                label-for="v-pricing"
              >
                <b-form-input
                  id="v-pricing"
                  v-model="dataForm.pricing"
                  placeholder="Create IOH username"
                />
              </b-form-group>
            </b-col>
            <b-col
              lg="4"
              sm="12"
            >
              <b-form-group
                label="Status"
                label-for="v-status"
              >
                <v-select
                  id="v-status"
                  v-model="dataForm.status"
                  :options="options.status"
                  :reduce="item => item.id"
                  label="label"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <div
            class="foot-form mt-2 float-right mb-2"
          >
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-secondary"
              class="mr-1"
              @click="formReset"
            >
              <span class="align-middle">Reset</span>
              <feather-icon
                icon="RotateCcwIcon"
                class="ml-50"
              />
            </b-button>
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="primary"
            >
              <span class="align-middle">Save</span>
              <feather-icon
                icon="SaveIcon"
                class="ml-50"
              />
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BModal, BRow, BCol, BFormGroup, BFormInput, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
// import { mapMutations } from 'vuex'

export default {
  components: {
    BModal,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    BButton,
  },
  directives: {
    Ripple,
  },
  props: {
    editFrom: {
      default: false,
      type: Boolean,
    },
    // eslint-disable-next-line vue/require-default-prop
    dataForm: Object,
    editStatus: {
      default: false,
      type: Boolean,
    },
    formTitle: {
      default: 'Text Title',
      type: String,
    },
  },
  data() {
    return {
      dataFormTemp: {},
      options: {
        method: [
          { id: 1, label: 'CPA' },
          { id: 2, label: 'CPC' },
        ],
        status: [
          { id: 2, label: 'Active' },
          { id: 3, label: 'Inactive' },
        ],
      },
    }
  },
  computed: {
    // ...mapGetters('campaign', {
    //   getListReason: 'getListReason',
    // }),
  },
  methods: {
    popupShow() {
      this.$refs['form-popup'].show()
    },
    popupHide() {
      this.$refs['form-popup'].hide()
    },
    formReset() {
      // if (this.editStatus) {
      //   console.log('Reset Edit Form')
      // } else {
      //   console.log('Reset Add Form')
      // }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.btn-close {
  position: absolute !important;
  right: 18px;
  top: 14px;
}
.modal-text > h4 {
  font-weight: bold;
  color: #000;
  border-bottom: 1px solid #d8d6de;
  padding-bottom: 15px;
}
.modal-text{
  padding:1rem;
  padding-top:0.7rem;
}
.modal-text label{
  font-size: 14px;
}
.form-s{
  padding:0.5rem;
}
</style>
